
<div class="notification-item {{class}}"   *ngIf="notification && !opened" >
  <div class="notification-item-header" *ngIf="!openInModal">
    <div class="circle" [ngClass]="notification.status === 'notSeen' ?'isRead' :''" (click)="seen(notification)"></div>
    <div class="date">{{date? date:stringAsDate(notification.createdAt) | date:'dd/MM/yy  HH:mm' }}</div>
    <div *ngIf="showRemove" class="delete" (click)="delete()" ><i class="fa fa-times"></i></div>
  </div>
  <div style="cursor: pointer" (click)="openPopupSeen(notification)">
    <div class="notification-item-body" *ngIf="notification.type === types.FRIEND_REQUEST">
      <span class="from">{{notification.forId.nickname}} :</span> &nbsp; <span>{{notification.messageContent}}</span>
    </div>
    <div class="notification-item-body" *ngIf="notification.type === types.PUBLISHER_REQUEST">
      <span class="from">{{notification.forId.name}} :</span> &nbsp; <span>{{notification.messageContent}}</span>
    </div>
    <div class="notification-item-body" *ngIf="notification.type === types.STANDARD || notification.type === types.TOURNAMENT_LINK || notification.type === types.QUESTION_FOR_DISPUTE || notification.type === types.ORDER_LINK">
      <span>{{notification.messageContent}}</span>
    </div>
    <div class="notification-item-body" *ngIf="notification.type === types.TEMPORARY_TEAM_INVITATION">
      <span>{{notification.messageContent}}</span>
      <app-team-invitation-widget-item [invitation]="notification.forId"></app-team-invitation-widget-item>
    </div>
    <div class="notification-item-body" *ngIf="notification.type === types.SHOW_WON_AMOUNT" style="text-align: center">
      <span>{{notification.metaData.title}}</span><br>
      <span>{{notification.messageContent}}:</span>&nbsp;
      <span *ngIf="notification.metaData.currency && !notification.metaData.multiplyPrize">
        {{notification.metaData.amount}} {{notification.metaData.currency}}
        <a (click)="showConvertMoney($event)" style="color:red; text-decoration: underline">{{'convert_money' | translate}}</a>
      </span>
      <span *ngIf="notification.metaData.ticket  && !notification.metaData.multiplyPrize">{{notification.metaData.ticket}}  <app-ticket></app-ticket></span>
      <span *ngIf="notification.metaData.point  && !notification.metaData.multiplyPrize">{{notification.metaData.point}} P</span>
      <span *ngIf="notification.metaData.multiplyPrize">
        <span *ngFor="let prize of notification.metaData.multiplyPrize.multiplyPrize">
                <span>{{prize.count}}  {{prize.currency}}</span>
        </span>
      </span>
      <span *ngIf="notification.metaData.sendTeamLeader">
        {{'send_team_leader' | translate}}
      </span>
    </div>
    <div class="notification-item-body" *ngIf="notification.type === types.ANSWER_FOR_DISPUTE">
      <h6>{{notification.messageContent}}</h6>
      <div *ngIf="disputeOne" class="row">
        <div class="col-md-8"><span>{{disputeOne.context}}</span></div>
        <div class="col-md-4"><span>{{disputeOne.status | translate}}</span></div>
      </div>
    </div>

    <div class="notification-item-body" *ngIf="notification.type === types.QUESTION">
      <h6>{{notification.messageContent}}</h6>
      <div *ngIf="notification.metaData.expireDate && notification.metaData.expireDate > dateNowNumber && notification.metaData.answer === undefined">
        <div class="cont">
          <div class="spinner"></div>
          <span class="number" >{{notification.metaData.expireDate | timer : ('soon' | translate) | async}}</span>
        </div>
      </div>
      <div *ngIf="notification.metaData.answer !== undefined">
        {{'yorAnswer' | translate}} : {{notification.metaData.actions[notification.metaData.answerIndex].displayName | translate}}
      </div>
      <div *ngIf="notification.metaData.answer === undefined && notification.metaData.expireDate < dateNowNumber">
        {{'expiredTime' | translate}}
      </div>
    </div>
  </div>

  <div class="notification-item-footer">
    <div *ngIf="notification.type === types.FRIEND_REQUEST && notification.status !== NotificationStatus.ACCEPTED && notification.status !== NotificationStatus.CANCELED" class="actions" >
      <app-primary-button text="{{'accept' | translate}}" className="small" (click)="answerFriendReq(answersFriendReq.ACCEPTED)"></app-primary-button>
      <app-secondary-button text="{{'refuse' | translate}}" className="small ml-0-5 bg-transparent" (click)="answerFriendReq(answersFriendReq.DECLINED)"></app-secondary-button>
    </div>
    <div *ngIf="notification.type === types.PUBLISHER_REQUEST && notification.status !== NotificationStatus.ACCEPTED && notification.status !== NotificationStatus.CANCELED" class="actions" >
      <app-primary-button text="{{'accept' | translate}}" className="small" (click)="answerPublisherInvitationReq(answersFriendReq.ACCEPTED)"></app-primary-button>
      <app-secondary-button text="{{'refuse' | translate}}" className="small ml-0-5 bg-transparent" (click)="answerPublisherInvitationReq(answersFriendReq.DECLINED)"></app-secondary-button>
    </div>
    <div *ngIf="notification.status === NotificationStatus.ACCEPTED" class="actions" >
      <span class="accepted">{{'accepted' | translate}}</span>
    </div>
    <div *ngIf="notification.status === NotificationStatus.CANCELED" class="actions" >
      <span class="accepted">{{'canceled' | translate}}</span>
    </div>
    <div *ngIf="notification.type === types.TOURNAMENT_LINK && notification.metaData && notification.metaData.challengeId" class="actions" >
      <app-primary-button text="{{'tournament_page' | translate}}" className="small" (onClick)="goToTournamentPage()"></app-primary-button>
    </div>
    <div *ngIf="notification.type === types.ORDER_LINK && notification.metaData && notification.metaData.orderId" class="actions" >
      <app-primary-button text="{{'order_page' | translate}}" className="small" (onClick)="goToOrderPage()"></app-primary-button>
    </div>
    <div *ngIf="notification.type === types.QUESTION" class="actions" >
      <div *ngIf="notification.metaData.answer === undefined && (!notification.metaData.expireDate || notification.metaData.expireDate > dateNowNumber)" class="actions-2">
        <app-primary-button *ngFor="let action of notification.metaData.actions" text="{{ action.displayName | translate}}" className="small" (click)="answerForQuestion(action.value)"></app-primary-button>
      </div>
      <div *ngIf="notification.metaData.answer === undefined">
        <span>{{notification.metadata?.answer}}</span>
      </div>
    </div>
  </div>

</div>


